import { Component, OnInit } from "@angular/core";
import { RouterService } from "src/app/services/router/router.service";
import { StorageService } from "src/app/services/storage/storage.service";
import { UserService } from "src/app/services/user/user.service";
import { ExceptionsService } from "src/app/exceptions/exceptions.service";
import { AlertService } from "src/app/services/alert/alert.service";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import firebase from "firebase/app";
import { CredentialsService } from "src/app/services/credentials/credentials.service";
import { AngularFireAuth } from "@angular/fire/auth";
import { AuthService } from "src/app/services/auth/auth.service";
import { RemoteConfigService } from "src/app/services/remote-config/remote-config.service";
import { environment } from "src/environments/environment";
import { LoaderService } from "src/app/services/loader/loader.service";
import { TagsService } from "src/app/services/tags/tags.service";
import { PlatformService } from "../../../services/platform/platform.service";
import { EmblueService } from "src/app/services/emblue/emblue.service";
import { FcmService } from "src/app/services/fcm/fcm.service";
import { first } from "rxjs/operators";

@Component({
  selector: "app-login-chat",
  templateUrl: "./login-chat.page.html",
  styleUrls: ["./login-chat.page.scss"],
})
export class LoginChatPage implements OnInit {
  firebaseDB;
  avatarProgram: string = "";
  token: any;
  tokenPush: any;
  constructor(
    private routerService: RouterService,
    private storageService: StorageService,
    private userService: UserService,
    private alertService: AlertService,
    public languageService: LanguagesService,
    public credentialsService: CredentialsService,
    public fireAuth: AngularFireAuth,
    public authService: AuthService,
    public remoteConfig: RemoteConfigService,
    public loaderService: LoaderService,
    private tagsService: TagsService,
    public platformService: PlatformService,
    private emblueService: EmblueService,
    private fcmService: FcmService
  ) {}
  messageError: any;
  answersOnMemory: any = [];
  authMethods: any = {};
  unifiedQuestions: boolean = true;
  siteKey: string = '';
  info = [
    {
      type: "text",
      data: "Soy el teniente GNXMVP, esto es un texto de prueba ",
      order: 0,
    },
    // {
    //   type: "image",
    //   data: "https://www.elmundo.cr/wp-content/uploads/2018/08/img.jpg",
    //   order: 2,
    // },
  ];

  ngOnInit() {
    this.firebaseDB = firebase;
    this.getAuthMethods();
    //this.getAnswersOnMemory();
    this.getUnifiedQuestions();
    this.getKeySite();
  }

  async getUnifiedQuestions() {
    return this.remoteConfig.getUnifiedQuestions().subscribe((res) => {
      this.unifiedQuestions = res;
    });
  }

  async getKeySite() {
    this.remoteConfig.getKeySite().subscribe((res) => {
      this.siteKey = res;
      console.log(this.siteKey);
      
    });
  }

  async getAnswersOnMemory() {
    const answers = await this.storageService.get("chat-answers");
    if (answers) {
      this.answersOnMemory = answers;
    }
  }

  getResponses = (event: any) => {
    this.storageService.set("chat-answers", event.detail);
  };

  async senForm(event) {
    const answersAndsQuestions = event.detail.questionsAndAnswers;
    await this.loaderService.presentLoading("form_loading");
    let email = "";
    if (!this.authMethods.phone && this.authMethods.email) {
      email = answersAndsQuestions[5].answer;
    }

    const uid = event.detail.credentials.account.id;
    if (!this.authMethods.phone && this.authMethods.email) {
      const user = await this.fireAuth.currentUser;
      if (!user.emailVerified) {
        const actionCodeSettings = {
          // url: `https://gnx-mvp.firebaseapp.com/auth-confirmation?email=${args}`,
          url: environment.dinamycLink.url,
          android: {
            packageName: environment.dinamycLink.packageName,
            installApp: true,
            minimumVersion: "0.0.1",
          },
          handleCodeInApp: true,
          dynamicCodeInApp: environment.dinamycLink.packageName,
        };
        await user.sendEmailVerification();
        this.alertService.presentAlert(
          `Para confirmar tu nueva cuenta debes visitar el link de confirmacion que enviamos a tu correo ${email}`
        );
      }
    }
    const answers = this.filterOnlyAnswers(answersAndsQuestions);
    let userAnswers: any = {};
    answers.map((data) => {
      userAnswers = {
        [data.name]: data.answer,
        ...userAnswers,
      };
    });
    userAnswers.email = userAnswers.firebaseCredential1;
    userAnswers.registerDate = new Date();
    delete userAnswers.firebaseCredential2;
    userAnswers.urlAvatar = environment.img_profile_default;
    try {
      if (!this.authMethods.phone && this.authMethods.email) {
        await this.userService.saveUserExtraInfo(userAnswers, uid);
        await this.emlue();
        await this.loaderService.cancelLoader("form_loading");
        this.authService.logout();
        return this.routerService.redirect("login");
      }
      if (this.authMethods.phone) {
        userAnswers.phone = userAnswers.firebaseCredential1;
        delete userAnswers.email;
        await this.userService.saveUserExtraInfo(userAnswers, uid);
        const tokenFB = await this.authService.callFbToken();
        const tokenGnx = await this.authService.getAccessFromUsers(tokenFB);
        this.authService.setCurrentTokenGnx(tokenGnx);
        await this.saveTokenGNX(tokenGnx);
        await this.emlue();
        await this.loaderService.cancelLoader("form_loading");
        return this.routerService.redirect("app/home");
      }
    } catch (err) {
      this.loaderService.cancelLoader("form_loading");
    }
  }


  async emlue(){
    await this.fcmService
    .getUserInfoUser()
    .pipe(first())
    .subscribe((user: any) => {
      if (user) {
        //console.log("user register",user);
        this.emblueService.getToken().then(async (token: any) => {
          let user_email = (user.email) ? user.email : 'mobile_' + user.phone.trim() + '@nomail.com';                
          this.token = token;
          this.tokenPush = this.fcmService.tokenFcm;
          var phone_user= this.emblueService.validationPhone(user.phone);
          let editCustomFields =
            "telefono_1:|:" +
            phone_user +
            ":|:1|||nombre:|:" +
            user.name +
            ":|:1|||apellido:|:" +
            user.lastnames +
            ":|:1|||id_contacto:|:" +
            user.gnxCredential1 +
            ":|:1|||email_secundario:|:" +
            user_email +
            ":|:1|||push_fb:|:" +
            this.tokenPush +
            ":|:1";
          //console.log("editCustomFields",editCustomFields);
          //console.log("tokens",   this.token, " fcm: ", this.tokenPush);
          this.emblueService
            .setAssociatePushToEmail(
              user_email,
              this.token,
              this.fcmService.tokenFcm
            )
            .then((data) => {
              console.log("setAssociatePushToEmail", data);
              this.emblueService
                .setNewContact(user_email, editCustomFields, this.token)
                .then((result) => {
                  console.log("setNewContact", result);
                });
            });
        });
      }
    });
  }
  async saveTokenGNX(tokenGNX: any) {
    if (tokenGNX.match) {
      await this.storageService.set("gnx-token", tokenGNX);
    }
    return this.routerService.redirect("app/home");
  }

  filterOnlyAnswers(answersAndQuestions) {
    return answersAndQuestions.filter((ans) => {
      return ans.type === "answer";
    });
  }
  get getTextIULoginChat() {
    return this.languageService.textsIU.page_login_chat;
  }
  errorsHandler(err) {
    console.log(err);
    if (typeof err === "string" || err instanceof String) {
      if (err === "USER_NOT_FOUND") {
        return this.alertService.presentAlert("Credenciales incorrectas");
      }
    }
    if (err.detail === "DUPLICATE_PHONE") {
      return this.alertService.presentAlert(
        "Este celular no se puede usar, intenta con otro nuevamente"
      );
    }
    if (err.detail === "ACCESS_DENIED") {
      return this.alertService.presentAlert(
        "No puedes ingresar con esta cuenta, verifica tus credenciales"
      );
    }
    if (err.detail === "CREDENTIALS_IN_USE") {
      this.alertService.presentAlert(
        "Usuario ya fue registrado, Inicia Sesión "
      );
      return this.routerService.redirect("login");
    }
    if (err.detail.code === "404") {
      return this.alertService.presentAlert("Credenciales incorrectas");
    }
    if (err.detail.code === "auth/email-already-in-use") {
      return this.alertService.presentAlert(
        "Este correo no se puede registrar"
      );
    }
    if (err.detail.code === "auth/too-many-requests") {
      return this.alertService.presentAlert("Hay un error inesperado");
    }
    if (err.detail == "ERROR VALID EMAIL") {
      return this.alertService.presentAlert(
        "El email no coincide con la confirmación de email, inténtalo de nuevo.");
    }
    if (err.type === "errorChat") {
      return this.alertService.presentAlert("Credenciales incorrectas");
    }
  }
  getCredentials = () => {
    return this.credentialsService.registerChat();
  };
  handlerCredentialsFromChat = (credentials) => {
    this.authService.userGnxId = credentials.detail.profile.id;
  };
  getAuthMethods = () => {
    this.remoteConfig.getSettingsAuthMethods().subscribe((res) => {
      console.log(res);
      this.authMethods = res;
    });
  };
  sendTags(event) {
    switch (event.detail.event) {
      case "register_extrainfo_viewed":
        this.tagsService.setEventTag(
          "register_extrainfo",
          "register_extrainfo_viewed",
          true
        );
        break;
      case "register_extrainfo_finish":
        this.tagsService.setEventTag(
          "register_extrainfo",
          "register_extrainfo_finish",
          true
        );
      default:
        console.log("wcomponent not found event");
        break;
    }
  }

  redirectTo(){
    this.routerService.redirect(`login`);
  }
}
